/**
 * Storage keys
 */
export const STORAGE_KEYS = {
  CART: "fs_cart",
  EVENT_QUEUE: "fs_event_queue",
  SESSION: "fs_session",
  FINGERPRINT: "fs_fingerprint",
  COUNTRY: "fs_country",
  LOCALE: "fs_locale",
  SERVER_SETTINGS: "fs_server_settings",
  SETTINGS_OVERRIDE: "fs_settings_override",
  ATTRIBUTION: "fs_attribution",
  ATTRIBUTION_CACHE: "fs_attribution_cache",
};
